import { Row, Col, Container } from "react-bootstrap";
import Styles from "./index.module.css";
import cx from "classnames";
import HeaderAds from "../Ads/header";

const WithHeaderAds = ({ children }) => {
  return (
    <Container>
      <Row>
        <Col xs={12} className={Styles.card}>
          <HeaderAds />
        </Col>
        <Col
          xs={12}
          className={cx("justify-content-center text-center", Styles.card)}
        >
          {children}
        </Col>
        <Col xs={12} className={Styles.card}>
          <HeaderAds />
        </Col>
      </Row>
    </Container>
  );
};

export default WithHeaderAds;
